import type { RefObject } from 'react';
import { findTransitionController } from '../../../../util/core-transition-component';
import type { HeadingRef } from '../../../atoms/heading/Heading.data';
import type { PrimaryLinkRef } from '../../../atoms/primary-link/PrimaryLink.data';

interface FeaturedNewsItemRefs {
  elementRef: RefObject<HTMLElement | null>;
  categoryRef: RefObject<HeadingRef | null>;
  dateRef: RefObject<HeadingRef | null>;
  titleRef: RefObject<HeadingRef | null>;
  downloadLinkRef?: RefObject<PrimaryLinkRef | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { categoryRef, titleRef, dateRef, downloadLinkRef }: FeaturedNewsItemRefs,
): void {
  const categoryController = findTransitionController(categoryRef);
  const titleController = findTransitionController(titleRef);
  const dateController = findTransitionController(dateRef);
  const downloadController = findTransitionController(downloadLinkRef);

  if (categoryController) {
    timeline.add(categoryController.getTimeline('in') as gsap.core.Timeline, 0);
  }

  if (titleController) {
    timeline.add(titleController.getTimeline('in') as gsap.core.Timeline, 0.1);
  }

  if (dateController) {
    timeline.add(dateController.getTimeline('in') as gsap.core.Timeline, 0.2);
  }

  if (downloadController) {
    timeline.add(downloadController.getTimeline('in') as gsap.core.Timeline, 0.2);
  }
}
